<template>
  <div>
    <div v-if="user.id == 1 || user.id == 24 || user.id == 25 || user.id == 18 || user.id == 5 || user.id == 6 || user.id == 7 || user.id == 8 || user.id == 9 || user.id == 10" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('dashboard')">
        <icon name="dashboard" class="w-4 h-4 mr-2" :class="isUrl('') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Dashboard</div>
      </inertia-link>
    </div>
    <div v-if="user.id == 1 || user.id == 24 || user.id == 25 || user.id == 3 || user.id == 5 || user.id == 6 || user.id == 7 || user.id == 8 || user.id == 17 || user.id == 9 || user.id == 10 || user.id == 18 || user.id == 21" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('customers')">
        <icon name="users" class="w-4 h-4 mr-2" :class="isUrl('customers') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('customers') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Clienti</div>
      </inertia-link>
    </div>
    <div v-if="user.id == 1 || user.id == 24 || user.id == 25 || user.id == 3 || user.id == 18 || user.id == 16 || user.id == 21" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('organizations')">
        <icon name="office" class="w-4 h-4 mr-2" :class="isUrl('organizations') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('organizations') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Stores</div>
      </inertia-link>
    </div>
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('products')">
        <icon name="store-front" class="w-4 h-4 mr-2" :class="isUrl('products') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('products') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Prodotti</div>
      </inertia-link>
    </div>    
    <div v-if="user.id == 1 || user.id == 24 || user.id == 25 || user.id == 3 || user.id == 4 || user.id == 16 || user.id == 18 || user.id == 21" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('batches')">
        <icon name="users" class="w-4 h-4 mr-2" :class="isUrl('batches') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('batches') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Lotti</div>
      </inertia-link>
    </div>
    <div v-if="user.id == 1 || user.id == 24 || user.id == 25 || user.id == 3 || user.id == 18 || user.id == 16 || user.id == 21" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('batchSales')">
        <icon name="shopping-cart" class="w-4 h-4 mr-2" :class="isUrl('batchSales') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('batchSales') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Vendita Lotti</div>
      </inertia-link>
    </div>
    <div v-if="user.id == 1 || user.id == 24 || user.id == 25 || user.id == 3 || user.id == 5 || user.id == 6 || user.id == 7 || user.id == 8 || user.id == 9 || user.id == 10 || user.id == 18" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('sales')">
        <icon name="shopping-cart" class="w-4 h-4 mr-2" :class="isUrl('sales') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('sales') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Venduti</div>
      </inertia-link>
    </div>
    <div v-if="user.id == 1 || user.id == 24 || user.id == 25 || user.id == 2 ||  user.id == 3 || user.id == 4 || user.id == 16 || user.id == 18 || user.id == 20 || user.id == 21 || user.id == 22 || user.id == 23" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('discharges')">
        <icon name="office" class="w-4 h-4 mr-2" :class="isUrl('discharges') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('discharges') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Scarico</div>
      </inertia-link>
    </div>
    <div v-if="user.id == 1 || user.id == 24 || user.id == 25 || user.id == 2 ||  user.id == 3 || user.id == 4 || user.id == 16 || user.id == 18 || user.id == 20 || user.id == 21 || user.id == 22 || user.id == 23" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('loadingProducts')">
        <icon name="office" class="w-4 h-4 mr-2" :class="isUrl('loadingProducts') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('loadingProducts') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Carico</div>
      </inertia-link>
    </div>
    <!-- <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('discountedLoadingProducts')">
        <icon name="office" class="w-4 h-4 mr-2" :class="isUrl('discountedLoadingProducts') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('discountedLoadingProducts') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Carico 50%</div>
      </inertia-link>
    </div> -->
    <div v-if="user.id == 1 || user.id == 24 || user.id == 25 || user.id == 5 || user.id == 6 || user.id == 7 || user.id == 8 || user.id == 9 || user.id == 10 || user.id == 18" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('cart')">
        <icon name="shopping-cart" class="w-4 h-4 mr-2" :class="isUrl('cart') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('cart') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Carrello</div>
      </inertia-link>
    </div>
    <!-- <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('contacts')">
        <icon name="users" class="w-4 h-4 mr-2" :class="isUrl('contacts') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('contacts') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Contacts</div>
      </inertia-link>
    </div> -->
    <!-- <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('reports')">
        <icon name="printer" class="w-4 h-4 mr-2" :class="isUrl('reports') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('reports') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Reports</div>
      </inertia-link>
    </div> -->
    <!-- <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('organizations1.edit')">
        <icon name="office" class="w-4 h-4 mr-2" :class="isUrl('organizations/1/edit') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('organizations/1/edit') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Furgone 1</div>
      </inertia-link>
    </div>
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('organizations2.edit')">
        <icon name="office" class="w-4 h-4 mr-2" :class="isUrl('organizations/2/edit') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('organizations/2/edit') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Furgone 2</div>
      </inertia-link>
    </div>
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('organizations3.edit')">
        <icon name="office" class="w-4 h-4 mr-2" :class="isUrl('organizations/3/edit') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('organizations/3/edit') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Furgone 3</div>
      </inertia-link>
    </div>
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('organizations4.edit')">
        <icon name="office" class="w-4 h-4 mr-2" :class="isUrl('organizations/4/edit') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('organizations/4/edit') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Furgone 4</div>
      </inertia-link>
    </div>
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('organizations5.edit')">
        <icon name="office" class="w-4 h-4 mr-2" :class="isUrl('organizations/5/edit') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('organizations/5/edit') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Furgone 5</div>
      </inertia-link>
    </div>
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('organizations6.edit')">
        <icon name="office" class="w-4 h-4 mr-2" :class="isUrl('organizations/6/edit') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('organizations/6/edit') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Furgone 6</div>
      </inertia-link>
    </div>
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('organizations7.edit')">
        <icon name="office" class="w-4 h-4 mr-2" :class="isUrl('organizations/7/edit') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('organizations/7/edit') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Furgone 7</div>
      </inertia-link>
    </div> -->
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'

export default {
  computed: {
    user() {
      return this.$page.props.auth.user
    },
  },
  components: {
    Icon,
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
  },
}
</script>
